import React from 'react';
import axios from 'axios';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import { toast } from 'react-toastify';
import { ListItemIcon } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import MenuIcon from '@mui/icons-material/Menu';
import { useControlKey } from '../../util/KeyPress';

const DataLoadMenu = ({ isVisible, onHide, showDataLoadMenu }) => {

    const handleShowMenu = () => {
        onHide();
        showDataLoadMenu();
    };

    const sendDataLoad = () => {
        onHide();
        axios.post('/dataload/send');
        toast.success('Data load sent');
    };

    useControlKey("q", sendDataLoad);

    return (
        <Menu
            id="data-load-menu"
            sx={{ top: '-10px' }}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            keepMounted
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            open={isVisible}
            onClose={onHide}
        >
            <MenuItem onClick={sendDataLoad}>
                <ListItemIcon>
                    <SendIcon fontSize="small" />
                </ListItemIcon>
                Send Data
            </MenuItem>
            <MenuItem onClick={handleShowMenu}>
                <ListItemIcon>
                    <MenuIcon fontSize="small" />
                </ListItemIcon>
                Show Menu
            </MenuItem>
        </Menu>
    );
};

export default DataLoadMenu;
